// import React from "react";

// const images = require.context("../images", true);
// const images_list = images.keys().map((image) => images(image));

// export default function Gallery() {
//   console.log(images_list[0]);

//   return (
//     <section id="gallery" className="gallery">
//       <div className="gallery-grid">
//         {images_list.map((image, index) => (
//           <div className="gallery-photo">
//             <img key={index} src={images_list[index]} />
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

import React, { useState } from "react";
import "../styles/Gallery.css";

const imageData = [
  { file: require("../gallery/1.jpg"), caption: "Dingwalls2" },
  { file: require("../gallery/2.jpg"), caption: "James and his Lemsip" },
  { file: require("../gallery/3.jpg"), caption: "Sick crowd", fullWidth: true },
  { file: require("../gallery/4.jpg"), caption: "In the studio" },
  { file: require("../gallery/5.jpg"), caption: "Calamity Tank" },
  { file: require("../gallery/6.jpg"), caption: "Leo" },
  { file: require("../gallery/7.jpg"), caption: "Leo & James" },
  { file: require("../gallery/8.jpg"), caption: "Morgan & James" },
  { file: require("../gallery/9.jpg"), caption: "Post gig pint" },
  { file: require("../gallery/10.jpg"), caption: "Moshing" },
  { file: require("../gallery/11.jpg"), caption: "Morgan" },
  {
    file: require("../gallery/12.jpg"),
    caption: "Be yourself",
    fullWidth: true,
  },
  { file: require("../gallery/13.jpg"), caption: "Star", fullWidth: true },
  { file: require("../gallery/14.jpg"), caption: "Killtaker", fullWidth: true },
  { file: require("../gallery/15.jpg"), caption: "Calamity Tank third time" },
  {
    file: require("../gallery/16.JPG"),
    caption: "Morgan singing on the floor",
  },
];

export default function Gallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((i) => i - 1);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((i) => i + 1);
  };

  return (
    <section id="gallery" className="gallery">
      <p id="info">*click images to enhance*</p>
      <div className="gallery-grid">
        {imageData.map(({ file, caption, fullWidth }, index) => (
          <div
            className={`gallery-photo ${fullWidth ? "full-width" : ""}`}
            key={index}
          >
            <img
              src={file}
              alt={caption}
              onClick={() => setSelectedIndex(index)}
            />
          </div>
        ))}
      </div>
      {selectedIndex !== null && (
        <div className="lightbox" onClick={() => setSelectedIndex(null)}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="lightbox-arrow-area lightbox-desktop-arrow">
              {selectedIndex > 0 && (
                <button className="lightbox-arrow" onClick={handlePrev}>
                  &lt;
                </button>
              )}
            </div>
            <div className="lightbox-center">
              <img
                src={imageData[selectedIndex].file}
                className="lightbox-image"
                alt={imageData[selectedIndex].caption}
              />
              <div className="lightbox-footer">
                <div className="lightbox-arrow-area">
                  {selectedIndex > 0 && (
                    <button className="lightbox-arrow" onClick={handlePrev}>
                      &lt;
                    </button>
                  )}
                </div>
                {imageData[selectedIndex].caption && (
                  <p className="lightbox-caption">
                    {imageData[selectedIndex].caption}
                  </p>
                )}
                <div className="lightbox-arrow-area">
                  {selectedIndex < imageData.length - 1 && (
                    <button className="lightbox-arrow" onClick={handleNext}>
                      &gt;
                    </button>
                  )}
                </div>
                <button
                  className="lightbox-arrow lightbox-close"
                  onClick={() => setSelectedIndex(null)}
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="lightbox-arrow-area lightbox-desktop-arrow">
              {selectedIndex < imageData.length - 1 && (
                <button className="lightbox-arrow" onClick={handleNext}>
                  &gt;
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
